module.exports = __webpack_public_path__ + "img/icon_5_73.107f9b7e.png";